import TicketManage from '@/pages/invoiceManage/ticketManage'

export default [
  {
    path: '/TicketManage',
    name: 'TicketManage',
    component: TicketManage,
    meta: { name: '开票管理' }
  }
]



// WEBPACK FOOTER //
// ./src/router/invoiceManage/ticketManage.js